<div class="grid grid-e5">
	<tec-stats
		[title]="'PANEL.STATS.TOTAL' | translate"
		[value]="stats?.all?.value?.toString()"
		[tagRounded]="getTagRounded(stats?.all?.delta_vs_previous)"
		[size]="'sm'"
		[loading]="loading()"
	>
		@if (rolePermissions.canViewPanelDeveloperCurl()) {
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal('PANEL.CURL_MODAL.TITLE_TOTAL_PROCESSES')"
			/>
		}
	</tec-stats>

	<tec-stats
		[title]="'PANEL.STATS.APPROVED' | translate"
		[value]="stats?.validated?.value?.toString()"
		[tagRounded]="getTagRounded(stats?.validated?.delta_vs_previous)"
		[size]="'sm'"
		[loading]="loading()"
	>
		@if (rolePermissions.canViewPanelDeveloperCurl()) {
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal('PANEL.CURL_MODAL.TITLE_APPROVED_PROCESSES')"
			/>
		}
	</tec-stats>

	<tec-stats
		[title]="'PANEL.STATS.PENDING' | translate"
		[value]="stats?.pending?.value?.toString()"
		[tagRounded]="getTagRounded(stats?.pending?.delta_vs_previous)"
		[size]="'sm'"
		[loading]="loading()"
	>
		@if (rolePermissions.canViewPanelDeveloperCurl()) {
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal('PANEL.CURL_MODAL.TITLE_PENDING_PROCESSES')"
			/>
		}
	</tec-stats>
	
	<tec-stats
		[title]="'PANEL.STATS.REJECTED' | translate"
		[value]="stats?.rejected?.value?.toString()"
		[tagRounded]="getTagRounded(stats?.rejected?.delta_vs_previous)"
		[size]="'sm'"
		[loading]="loading()"
	>
		@if (rolePermissions.canViewPanelDeveloperCurl()) {
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal('PANEL.CURL_MODAL.TITLE_REJECTED_PROCESSES')"
			/>
		}
	</tec-stats>

	<tec-stats
		[title]="'PANEL.STATS.ABANDONED' | translate"
		[value]="stats?.incomplete?.value?.toString()"
		[tagRounded]="getTagRounded(stats?.incomplete?.delta_vs_previous)"
		[size]="'sm'"
		[loading]="loading()"
	>
		@if (rolePermissions.canViewPanelDeveloperCurl()) {
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal('PANEL.CURL_MODAL.TITLE_ABANDONED_PROCESSES')"
			/>
		}
	</tec-stats>
</div>

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="curlModalTitleKey()"
		[curlText]="getTotalProcessDateCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
